import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HomePage } from "./components/HomePage/HomePage";
import { ForgotPasswordPage } from "./components/ForgotPasswordPage/ForgotPasswordPage";
import { RegistrationForm } from "./components/HomePage/RegistrationForm/RegistrationForm";
import { OTPForm } from "./components/HomePage/OTPForm/OTPForm";
import { PinGenSection } from "./components/HomePage/PinGenSection/PinGenSection";
import { WelcomeSection } from "./components/HomePage/WelcomeSection/WelcomeSection";

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Routes>
          <Route path="/" exact element={<HomePage />} />
          {/* <Route path="/fill-otp" exact element={<OTPForm />} />
          <Route path="/generate-pin" exact element={<PinGenSection />} />
          <Route path="/welcome" exact element={<WelcomeSection />} /> */}
          <Route
            path="/forgot-password"
            exact
            element={<ForgotPasswordPage />}
          />
        </Routes>
        <img
          className="bg-white-sub"
          src="./assets/white-subtract.png"
          alt="bg-w-sub"
        />
        <img
          className="md-white-sub"
          src="./assets/white-subtract.png"
          alt="md-w-sub"
        />
        <img
          className="sm-white-sub"
          src="./assets/white-subtract.png"
          alt="sm-w-sub"
        />
        <img
          className="bg-brown-sub"
          src="./assets/brown-subtract.png"
          alt="bg-b-sub"
        />
        <img
          className="md-brown-sub"
          src="./assets/brown-subtract.png"
          alt="md-b-sub"
        />
        <img
          className="sm-brown-sub"
          src="./assets/brown-subtract.png"
          alt="sm-b-sub"
        />
      </div>
    </BrowserRouter>
  );
}

export default App;
